import { formatAddress } from '../../../../components/address-book/utils/format-address';
import { AddressForm } from '../../../../global-types/addresses';
import { saveQuickAddress } from '../../../../services/address';

export const handleSaveQuickAddressFromAddressForm = async (addressForm: AddressForm) => {
  if (addressForm.isQuickAddress) {
    await saveQuickAddress({
      ...formatAddress(addressForm),
      skip_address_verification: addressForm.skip_usps_validation || false,
      contact_type_code: 'A',
    });
  }
};
